import { parseISO, getYear, getMonth, getDate, subMonths, endOfMonth, startOfMonth, format, isAfter, } from 'date-fns';
/**
 * Returns year array from startDate’s year to today’s year
 *
 * Returns previous year if it is first day of the year
 * This is because statements are calculated till previous day from today only
 *
 * Returns [endYear] startDate is undefined
 *
 * Returns [] if startDate is greater than endYear
 */
export const getYearRange = (startDate) => {
    const currentDate = new Date();
    const currentDay = getDate(currentDate);
    const currentYear = getYear(currentDate);
    const currentMonth = getMonth(currentDate);
    const endYear = currentMonth === 0 && currentDay === 1 ? currentYear - 1 : currentYear;
    if (!startDate) {
        return [endYear];
    }
    const startYear = getYear(parseISO(startDate));
    if (endYear < startYear) {
        return [];
    }
    const dateRange = [];
    for (let year = startYear; year <= endYear; year++) {
        dateRange.push(year);
    }
    return dateRange;
};
export const getDateInfo = (date) => {
    const today = new Date();
    const dateObj = new Date(date);
    const todayYear = today.getFullYear();
    const lastMonth = subMonths(today, 1);
    const endOfLastMonth = endOfMonth(lastMonth);
    const startOfLastMonth = startOfMonth(lastMonth);
    const currentTaxYearStartDate = `${todayYear}-04-06`;
    const currentTaxYearStartDateObj = new Date(currentTaxYearStartDate);
    const data = [
        {
            title: 'Last month',
            to: format(endOfLastMonth, 'yyyy-MM-dd'),
            from: format(startOfLastMonth, 'yyyy-MM-dd'),
            description: `${format(startOfLastMonth, 'd MMM, yyyy')} - ${format(endOfLastMonth, 'd MMM, yyyy')}`,
        },
    ];
    let usedYear;
    if (isAfter(today, currentTaxYearStartDateObj)) {
        usedYear = todayYear;
        const from = `${todayYear}-04-06`;
        const to = `${todayYear + 1}-04-05`;
        data.push({
            title: 'Current tax year',
            to: format(to, 'yyyy-MM-dd'),
            from: format(from, 'yyyy-MM-dd'),
            description: `${format(from, 'd MMM, yyyy')} - ${format(to, 'd MMM, yyyy')}`,
        });
    }
    else {
        usedYear = todayYear - 1;
        const from = `${todayYear - 1}-04-06`;
        const to = `${todayYear}-04-05`;
        data.push({
            title: 'Current tax year',
            to: format(to, 'yyyy-MM-dd'),
            from: format(from, 'yyyy-MM-dd'),
            description: `${format(from, 'd MMM, yyyy')} - ${format(to, 'd MMM, yyyy')}`,
        });
    }
    const prevYear = usedYear - 1;
    const prevTaxYearStartDate = `${prevYear}-04-06`;
    const prevTaxYearStartDateObj = new Date(prevTaxYearStartDate);
    if (isAfter(prevTaxYearStartDateObj, dateObj)) {
        const from = `${prevYear}-04-06`;
        const to = `${prevYear + 1}-04-05`;
        data.push({
            title: 'Last tax year',
            to: format(to, 'yyyy-MM-dd'),
            from: format(from, 'yyyy-MM-dd'),
            description: `${format(from, 'd MMM, yyyy')} - ${format(to, 'd MMM, yyyy')}`,
        });
    }
    return data;
};
